/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-duplicate-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { h } from 'preact';
import styled from 'styled-components';
import { useEffect, useRef } from 'preact/hooks';
import Icon1 from '@images/hm.svg';
import { isWeiXinAndQQ } from '../../../utils/utils';
const TbItem: any = ({ item, scene = '', setItem }: any) => {
  return (
    <Container
      className="live-item"
      onClick={() => {
        setItem(item);
      }}
    >
      <Icon loading="lazy" src={item.main_pic || item.image_url} />
      <Title>{item.title}</Title>
      <PriceOut>
        <Price>直播价:&nbsp;<PriceBig>{item.activity_price=="0.00"?"？":`¥${item.activity_price}`}</PriceBig></Price>
      </PriceOut>
      <SubBtn>{isWeiXinAndQQ() ? '复制口令' : '立即购买'}</SubBtn>
    </Container>
  );
};

export default TbItem;

const Container = styled.div`
  width: 342px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  margin-right: 18px;
  margin-top: 12px;
  border-radius: 12px;
  overflow: hidden;
  padding-bottom: 12px;
`;
const Icon = styled.img`
  width: 342px;
  height: 342px;
`;

const Title = styled.div`
  margin-top: 12px;
  padding: 0 10px;
  width: 100%;
  font-weight: 500;
  color: #2d2d2d;
  font-size: 26px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 这里是超出几行省略 */
  overflow: hidden;
  line-height: 34px;
`;
const SubBtn = styled.div`
  margin-top: 14px;
  width: 256px;
  height: 52px;
  /* background: linear-gradient(270deg, #F45D17 0%, #EB9F1C 100%); */
  background: linear-gradient(270deg, #8f64f5 0%, #a59bfb 100%);
  border-radius: 26px;
  font-weight: 500;
  color: #ffffff;
  font-size: 26px;
  line-height: 52px;
  text-align: center;
`;

const PriceOut=styled.div`
   
`;
const Price=styled.div`
   font-weight: 500;
   color: #ee88ad;
   font-size:24px;
`;
const PriceBig=styled.span`
   font-size:32px;
   position: relative;
   top: 2px;
`